import React from 'react';
import { Box, Tabs, Tab, useMediaQuery, useTheme } from '@mui/material';

// const tabs = ['Reservations', 'Issuable', 'Purchases', 'Workbenches'];
// Hiding 'Purchases' and 'Workbenches' for now until we have sample data
const tabs = ['Reservations', 'Issuable'];

const TopBarComponent = ({ activeTab, setActiveTab }) => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleChange = (_, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: { xs: 'center', sm: 'flex-start' },
        px: { xs: 1, sm: 2 },
        py: 1,
        mt: 2,
      }}
    >
      <Tabs
        value={activeTab}
        onChange={handleChange}
        variant={isMobile ? 'scrollable' : 'standard'}
        scrollButtons="auto"
        allowScrollButtonsMobile
        TabIndicatorProps={{ style: { display: 'none' } }}
        sx={{
          background: '#FCFCFC',
          borderRadius: '10px',
          p: { xs: '3px', sm: '4px' },

          '& .MuiTabs-flexContainer': {
            gap: { xs: '4px', sm: '8px', md: '12px' },
          },

          '& .MuiTab-root': {
            textTransform: 'none',
            fontWeight: 400,
            borderRadius: '8px',
            minHeight: '36px',

            px: {
              xs: 1,
              sm: 2,
              md: 3,
            },

            fontSize: {
              xs: '13px',
              sm: '14px',
              md: '15px',
            },
          },

          '& .Mui-selected': {
            background: '#fff',
            border: '1px solid #979797',
            boxShadow: '2px 2px 8px rgba(0,0,0,0.1)',
          },
        }}
      >
        {tabs.map((tab, index) => (
          <Tab key={tab} label={tab} value={index} />
        ))}
      </Tabs>
    </Box>
  );
};

export default TopBarComponent;
